// src/components/Forbidden.js
import React from 'react';

const Forbidden = () => {
  return (
    <div>
      <h1>403 - Forbidden</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default Forbidden;
